/**
 * The Daily Drop is keyed by the UTC date (04 §11): everyone, everywhere, flies the same day.
 * The screen layer may read the clock; the pure layers only ever see this string.
 */

/** `YYYY-MM-DD` in UTC. An invalid date falls back to the epoch rather than printing `NaN`. */
export function utcDate(now: Date = new Date()): string {
  const d = Number.isFinite(now.getTime()) ? now : new Date(0);
  const two = (n: number): string => (n < 10 ? `0${n}` : String(n));
  const year = String(d.getUTCFullYear()).padStart(4, '0');
  return `${year}-${two(d.getUTCMonth() + 1)}-${two(d.getUTCDate())}`;
}
